module.exports = __webpack_public_path__ + "img/oudi.7b9527ff.jpeg";